export const classes = {
  root: {
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    height: '100vh',
  },
};
